var React = require('react');

function Untangle (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"id":"big","cx":"378.1","cy":"207.4","rx":"136","ry":"137.1","key":0}),React.createElement("circle",{"id":"small","cx":"524.7","cy":"270.4","r":"27.1","key":1}),React.createElement("circle",{"id":"midbig","cx":"178","cy":"207.4","r":"90.1","key":2}),React.createElement("ellipse",{"id":"midsmall","cx":"200.9","cy":"115.6","rx":"56.5","ry":"55.9","key":3})]);
}

Untangle.defaultProps = {"id":"untangle","data-name":"untangle","viewBox":"0 0 639.7 404.3"};

module.exports = Untangle;

Untangle.default = Untangle;
